import { LendingVaultExpanded } from "@bridgesplit/abf-react";
import { VaultMetadataTag } from "@bridgesplit/abf-sdk";
import {
    AppsOutlined,
    LocalAtmOutlined,
    LayersOutlined,
    CurrencyExchangeOutlined,
    CurrencyBitcoinOutlined,
    WhatshotOutlined,
    StarBorderOutlined
} from "@mui/icons-material";
import { LEND_VAULT_DETAIL_SLUG, VAULT_MANAGER_SLUG } from "app/constants";

export function getLendingVaultPath(lendVault: LendingVaultExpanded | undefined) {
    if (!lendVault) return "#";
    const identifier = lendVault.vault.vaultIdentifier ?? lendVault.vault.address;
    return `${LEND_VAULT_DETAIL_SLUG}/${identifier}`;
}

export function getVaultManagerPath(lendVault: LendingVaultExpanded | undefined) {
    if (!lendVault) return "#";
    const identifier = lendVault.vault.vaultIdentifier ?? lendVault.vault.address;
    return `${VAULT_MANAGER_SLUG}/${identifier}`;
}

type VaultFilterMeta = {
    icon: JSX.Element;
    label: string;
    shortLabel: string;
    tag: VaultMetadataTag;
    sortPosition: number;
    hideInCategories?: boolean;
};

export const VAULT_FILTER_TAG_ORDER: readonly VaultMetadataTag[] = [
    VaultMetadataTag.All,
    VaultMetadataTag.Featured,
    VaultMetadataTag.Popular,
    VaultMetadataTag.Stablecoins,
    VaultMetadataTag.SOL,
    VaultMetadataTag.LP,
    VaultMetadataTag.BTC
];

const VAULT_FILTER_METADATA: Record<VaultMetadataTag, Omit<VaultFilterMeta, "tag" | "sortPosition">> = {
    [VaultMetadataTag.All]: { icon: <AppsOutlined />, label: "All", shortLabel: "All", hideInCategories: true },
    [VaultMetadataTag.Popular]: { icon: <WhatshotOutlined />, label: "Popular", shortLabel: "Popular" },
    [VaultMetadataTag.Featured]: { icon: <StarBorderOutlined />, label: "Featured", shortLabel: "Featured" },
    [VaultMetadataTag.Stablecoins]: { icon: <LocalAtmOutlined />, label: "Stablecoins", shortLabel: "Stables" },
    [VaultMetadataTag.SOL]: { icon: <LayersOutlined />, label: "SOL & LST", shortLabel: "SOL/LST" },
    [VaultMetadataTag.LP]: { icon: <CurrencyExchangeOutlined />, label: "LP", shortLabel: "LPs" },
    [VaultMetadataTag.BTC]: { icon: <CurrencyBitcoinOutlined />, label: "BTC", shortLabel: "BTC" }
};

export function getVaultFilterMetadata(tag: VaultMetadataTag | undefined): VaultFilterMeta | undefined {
    if (!tag || !(tag in VAULT_FILTER_METADATA)) return undefined;
    return {
        ...VAULT_FILTER_METADATA[tag],
        tag,
        sortPosition: VAULT_FILTER_TAG_ORDER.indexOf(tag)
    };
}
